




























































import { Component, Prop, PropSync } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import {
  defaultSystemCode,
  SystemCode,
  systemCodeApi,
  SystemCodeWithKey
} from '@/api'
import DataTable from '@/components/molecules/DataTable/DataTable.vue'
import { CODE_KEY } from '@/config'
import { systemCodeStore } from '@/utils/store-accessor'
import { Col } from '@/components/molecules/DataTable'
import { UsageStatisticsReferenceTableItem } from '@/components/organisms/UsageStatisticsReferenceTable/UsageStatisticsReferenceTable.vue'
import InputCode from '@/components/molecules/InputCode/InputCode.vue'

export interface UsageStatisticsEventTableItem {
  isRegistered: boolean
  eventType: {
    input: string
    shortName: string
    errorMessage: string
  }
  counter: {
    input: string
  }
  inputs: UsageStatisticsEventTableItemInput[]
}

export const defaultUsageStatisticsEventTableItem = (): UsageStatisticsEventTableItem => ({
  isRegistered: false,
  eventType: {
    input: '',
    shortName: '',
    errorMessage: ''
  },
  counter: {
    input: '0'
  },
  inputs: systemCodeStore
    .filterByCodeKey(CODE_KEY.STATISTICS_USER_TYPE.KEY)
    .map(systemCode => {
      return {
        userType: systemCode,
        counter: {
          input: '0'
        }
      }
    })
})

interface UsageStatisticsEventTableItemInput {
  userType: SystemCode
  counter: {
    input: string
  }
}

const defaultUsageStatisticsEventTableItemInput = (): any => ({
  userType: defaultSystemCode(),
  counter: {
    input: '0'
  }
})

@Component({
  components: { InputCode, DataTable }
})
export default class UsageStatisticsEventTable extends ComponentVue {
  @PropSync('inputs', {
    type: Array,
    required: true
  })
  inputItems!: UsageStatisticsEventTableItem[]

  @Prop({
    type: Number,
    required: true
  })
  height!: number

  get numberMask(): string {
    return '#'.repeat(5)
  }

  get eventTypeSystemCodeWithKey(): Promise<SystemCodeWithKey> {
    return systemCodeApi.getSystemCodeWithKey(CODE_KEY.EVENT_TYPE.KEY)
  }

  get reverseInputItems(): UsageStatisticsEventTableItem[] {
    return [...this.inputItems].reverse()
  }

  get inputTargetObject(): any {
    return (tableRow: UsageStatisticsReferenceTableItem, code: string) => {
      return (
        tableRow.inputs.find(input => input.userType.code === code) ??
        defaultUsageStatisticsEventTableItemInput()
      )
    }
  }

  get cols(): Col[] {
    if (this.statisticsUserTypeSystemCodes.length === 0) {
      return []
    }

    const width: number = Math.round(
      100 / (this.statisticsUserTypeSystemCodes.length + 2)
    )

    return [
      {
        width: 50,
        items: [
          {
            name: 'descNo',
            align: 'right'
          }
        ]
      },
      {
        width: String(
          Math.round(
            (100 - width * this.statisticsUserTypeSystemCodes.length) / 2
          )
        ),
        resizable: true,
        items: [
          {
            name: 'eventType',
            headerText: 'コード'
          }
        ]
      },
      {
        width: String(
          Math.round(
            (100 - width * this.statisticsUserTypeSystemCodes.length) / 2
          )
        ),
        resizable: true,
        items: [
          {
            name: 'counter',
            headerText: '回数'
          }
        ]
      },
      ...this.statisticsUserTypeSystemCodes.map(systemCode => {
        return {
          width: String(width),
          resizable: true,
          items: [
            {
              name: systemCode.code,
              headerText: systemCode.shortName
            }
          ]
        }
      }),
      {
        width: 30,
        items: [
          {
            name: 'remove',
            align: 'center'
          }
        ]
      }
    ]
  }

  get statisticsUserTypeSystemCodes(): SystemCode[] {
    return systemCodeStore.filterByCodeKey(CODE_KEY.STATISTICS_USER_TYPE.KEY)
  }

  existsErrorMessage(errorMessage: string): boolean {
    return errorMessage !== ''
  }

  resetErrorMessage(obj: any): void {
    obj.errorMessage = ''
  }

  onClickRemove(index: number): void {
    if (this.inputItems.length === 1) {
      this.inputItems = [defaultUsageStatisticsEventTableItem()]
      return
    }

    this.inputItems.splice(this.inputItems.length - index - 1, 1)
  }

  onClickAddRow(): void {
    if (
      this.inputItems.length > 0 &&
      this.inputItems[this.inputItems.length - 1].eventType.input === ''
    ) {
      return
    }

    this.inputItems.push(defaultUsageStatisticsEventTableItem())
  }
}
